export default "__VITE_ASSET__Dqn__v6h__"